export type HistoryRequest = {
  message: string;
  data: data;
};

export type data = {
  stock_item_requests: StockItemRequestClass[];
};

export type StockItemRequest = {
  data: Data | StockItemRequestMessages;
  message: string;
};

export type Data = {
  stock_item_request: StockItemRequestClass;
};

export type StockItemRequestClass = {
  id: number;
  subject: string;
  request_type: string;
  payment_type: string;
  pay_within: string;
  hold_hours: null;
  time_remaining: string;
  expired_on: null;
  request_notification_msg: string;
  offer_price_per_carat: string;
  offer_total_sales_price: string;
  comments: string;
  status: string;
  notes: string;
  tracking_status: null;
  unread_messages_count: number;
  created_at: string;
  updated_at: string;
  view_type: string;
  show_rating_popup: boolean;
  original_seller_location: Location;
  seller_location: Location;
  buyer_location: Location;
  purchase_agent: boolean;
  bmh_request_type: null;
  secondary_request_type: null;
  parent_id: null;
  deep_link: string;
  offer_discount_percent: string;
  short_title: string;
  stock_item_type: string;
  stock_item_request_deep_link: string;
  additional_attributes: StockItemRequestAdditionalAttributes;
  configuration_details: null;
  quantity: null;
  offer_size: null;
  can_request_to_supplier: boolean;
  vendor_info: VendorInfo;
  diamond: Diamond;
  read: boolean;
  children?: StockItemRequestClass[];
  total_listed_price: string;
  shareable_link: ShareableLink;
  quote_details: QuoteDetails;
  route_id?: string;
  track_status: string;
  track_status_color: string;
  track_comment: string;
  memo_status?: MemoStatus;
  company_identifier?: string;
  translated_payment_type?: string;
  product_sub_type: string;
  total_amount: string;
  order_id?: string;
  track_status_key?: string;
  available_actions?: any;
  order_cart_pricing?: any;
  is_jewelry_order?: boolean;
};

export type QuoteDetails = {
  is_user_registered: boolean;
  recipient_email: string;
  recipient_name: string;
  recipient_phone_country_code: string;
  recipient_phone_number: string;
  total_offer_price_applied: boolean;
  recipient_company_name: string;
  recipient_company_location: string;
};

export type StockItemRequestAdditionalAttributes = {
  locale: string;
  share_type: string;
};

export type ShareableLink = {
  title: string;
  link: string;
};

export type Location = {
  id: number;
  zip: string;
  city: string;
  buyer?: Buyer;
  state: string;
  country: string;
  website: string;
  vendor_id: number;
  created_at: string;
  is_primary: boolean;
  updated_at: string;
  company_name?: string;
  mobile_phone: string;
  office_phone: string;
  contact_email: string;
  location_name: string;
  contact_iphone: string;
  contact_person: string;
  street_address: string;
  contact_whatsapp: string;
  mobile_phone_country_code: string;
  contact_phone_country_code: string;
  contact_iphone_country_code: string;
  contact_whatsapp_country_code: string;
  has_multiple_locations?: boolean;
};

export type Buyer = {
  zip: string;
  city: string;
  name: string;
  email: string;
  state: string;
  country: string;
  website: string;
  username: string;
  referral_id: null;
  mobile_phone: string;
  phone_number: string;
  street_address: string;
  mobile_phone_country_code: string;
  phone_number_country_code: string;
};

export type Diamond = {
  id: number;
  stock_num: string;
  vendor_id: number;
  total_sales_price: number;
  size: string;
  city: string;
  state: null;
  country: string;
  available: number;
  cert_num: string;
  shape: string;
  color: string;
  meas_length: string;
  meas_width: string;
  meas_depth: string;
  meas_ratio: null;
  image_url: string;
  video_url: string;
  cert_url: string;
  price_per_carat: number;
  lab: string;
  treatment: string;
  data_integrity: boolean;
  sort_priority: number;
  master_diamond_id: null;
  mount_price: null;
  fancy_color_dominant_color: null;
  fancy_color_secondary_color: null;
  fancy_color_overtone: null;
  fancy_color_intensity: null;
  clarity: string;
  cut: string;
  symmetry: string;
  polish: string;
  depth_percent: string;
  table_percent: string;
  girdle_min: string;
  girdle_max: null;
  girdle_condition: string;
  culet_size: string;
  culet_condition: null;
  fluor_color: null;
  fluor_intensity: string;
  has_cert_file: boolean;
  currency_code: null;
  currency_symbol: string;
  total_sales_price_in_currency: null;
  short_title: string;
  is_separable: boolean;
  cash_price: null;
  crown_height: string;
  crown_angle: string;
  pavilion_depth: null;
  pavilion_angle: string;
  laser_inscription: null;
  hearts_and_arrows: null;
  cert_comment: null;
  trade_show: null;
  cash_discount: null;
  parcel_stones: null;
  comments: string;
  eye_clean: string;
  star_length: null;
  shade: null;
  milky: null;
  inclusion_black: null;
  inclusion_center: null;
  inclusion_open: null;
  availability_change_date: null;
  discount_percent: string;
  sell_price: null;
  bgm: null;
  hidden: boolean;
  transcoding_job: null;
  transcoding_status: null;
  transcoded_video_data: null;
  orbital_source_url: null;
  transcoded_video_url: null;
  video_support: string;
  bad_fields: string[];
  has_bad_data: boolean;
  data: DataClass;
  girdle_percent: null;
  gem_type: null;
  country_of_origin: null;
  pair: string;
  metals: null;
  brand: null;
  history: null;
  created_at: string;
  updated_at: string;
  treatment_notes: null;
  orbital_url: null;
  whitelisted_video: boolean;
  gdrive_image_url: null;
  gdrive_video_url: null;
  image_source: null;
  image_source_url: null;
  video_source: null;
  video_source_url: null;
  cert_source: null;
  cert_source_url: null;
  source_errors: DataClass;
  jewelry_style: null;
  metal: null;
  mount: null;
  total_stones: null;
  center_type: null;
  center_gem_type: null;
  center_shape: null;
  center_color: null;
  center_clarity: null;
  center_fancy_color_dominant_color: null;
  center_fancy_color_intensity: null;
  center_fluor_intensity: null;
  center_lab: null;
  center_cert_num: null;
  center_treatment: null;
  center_total_stones: null;
  center_size: null;
  center_meas_depth: null;
  center_meas_length: null;
  center_meas_width: null;
  center_meas_ratio: null;
  center_polish: null;
  center_symmetry: null;
  center_cut: null;
  center_depth_percent: null;
  center_table_percent: null;
  center_pair: null;
  s3_image: S3Image;
  image_bad_http_status: boolean;
  image_check_ran_at: null;
  metal_carat: null;
  bad_video_content: boolean;
  s3_video: S3CERT;
  s3_cert: S3CERT;
  s3_direct_upload_url: DataClass;
  oscillating_video: boolean;
  video_bad_http_status: boolean;
  video_check_ran_at: null;
  is_thumb_resized: boolean;
  calculated_disc_perc: string;
  side_stone_type: null;
  side_stone_gem_type: null;
  side_stone_total_stones: null;
  side_stone_size: null;
  side_stone_shape: null;
  side_stone_color: null;
  side_stone_clarity: null;
  side_stone_fancy_color_dominant_color: null;
  side_stone_fancy_color_intensity: null;
  lab_grown: boolean;
  jewelry_description: null;
  lab_sync_status: boolean;
  owner_info: null;
  custom_sort_order: null;
  parcel_carat_range_from: null;
  parcel_carat_range_to: null;
  layout: null;
  diamond_category: null;
  pair_stock_num: null;
  is_customizable: null;
  visibility: string;
  growth_type: null;
  tinge: null;
  luster: null;
  location_of_black: null;
  table_inclusion: null;
  table_open: null;
  crown_open: null;
  girdle_open: null;
  pavallion_open: null;
  ownership: null;
  key_to_symbol: null;
  surface_graining: null;
  internal_graining: null;
  indented_natural: null;
  inclusion_pattern: null;
  dor: null;
  rapnet_price: string;
  lab_sequence_no: null;
  fm: null;
  intensity_black_code: null;
  natts_code: null;
  original_stone_no: null;
  stock_status: null;
  carat_group: null;
  carat_group_seq_no: null;
  live_rapa_rate: string;
  stone_detail_url: null;
  new_arrival_date: null;
  shape_sequence_no: null;
  color_sequence_no: null;
  clarity_sequence_no: null;
  certificate_date: null;
  price_date: null;
  color_inclusion: null;
  csv_discount: string;
  max_quantity: null;
  price_variant: null;
  item_tag: null;
  additional_attributes: DataClass;
  diamond_type: null;
  supported_shapes: null;
  scs_sustainable: null;
  scs_climate_neutral: null;
  certification: null;
  incremental_bid_amount: null;
  starting_bid: null;
  jewelry_type: null;
  sub_type: null;
  engravable: boolean;
  parent_id: null;
  tags: null;
  status: string;
  status_updated_at: null;
  jewelry_stock_num: null;
  custom_search_text: null;
  min_color: number;
  max_color: number;
  master_stock_number: null;
  config_field_1: null;
  config_field_2: null;
  cert_updated_at: null;
  sustainability: null;
  validation_errors: DataClass;
  flagged: null;
  is_master_product: null;
  three_d_enabled: null;
  product_title: null;
  product_description: null;
  setting_supported_carat_from: null;
  setting_supported_carat_to: null;
  tier: null;
  three_d_media: null;
  price_per_ct: string;
  diamond_id: number;
  on_hand: number;
  base_price_per_carat: string;
  base_price: string;
  buyer_price_per_carat: string;
  buyer_total_sales_price: string;
  in_cart: boolean;
  is_favorite: boolean;
  measurement: string;
  video_type: string;
  group_logo_url: null;
  group: null;
  mount_description: string;
  vendor_name: string;
  vendor_phone: string;
  vendor_mobile_phone: string;
  vendor_email: string;
  contact_person: string;
  vendor_street_address: string;
  vendor_city: string;
  vendor_state: string;
  vendor_country: string;
  vendor_zip_code: string;
  vendor_iphone: string;
  vendor_accepts_memo: boolean;
  last_updated_at: string;
  vendor_three_d_settings: null;
  image_thumb_url: string;
  shape_long: string;
  shape_short: string;
  clarity_long: string;
  clarity_short: string;
  cut_long: string;
  cut_short: string;
  polish_long: string;
  polish_short: string;
  symmetry_long: string;
  symmetry_short: string;
  fancy_color_long: null;
  fancy_color_short: null;
  fancy_color_intensity_long: null;
  fancy_color_intensity_short: null;
  fluorescence_intensity_long: string;
  fluorescence_intensity_short: string;
  lab_long: string;
  lab_short: string;
  culet_size_long: string;
  culet_size_short: string;
  girdle_min_long: string;
  girdle_min_short: string;
  girdle_max_long: null;
  girdle_max_short: null;
  fancy_color_overtone_long: null;
  fancy_color_overtone_short: null;
  is_fancy: boolean;
  estimated_delivery: null;
  supplier_comments: null;
  locations: Location[];
  original_ppc: null;
  original_tsp: null;
  group_original_tsp: null;
  group_original_ppc: null;
  group_original_discount: null;
  previewable: string;
  image_urls: ImageURL[];
  long_title: string;
  sub_title: string;
  retail_price: null;
  certification_details: CertificationDetails;
  media: null;
  disable_price_negotiation: boolean;
  currency_exchange_rate: null;
  special_price: null;
  type: string;
  custom_availability_stone_status: null;
  jbt_detail: null;
  is_linked_pair: boolean;
  is_linked_pair_parent: boolean;
  pairinfo: null;
  parcel_avg_weight: null;
  item_comment: string;
  supplier_specific_comment: string;
  masked_video_url: string;
  masked_image_url: string;
  masked_cert_url: string;
  sub_title_description: string;
  hide_price_per_carat: null;
  hide_total_sales_price: null;
};

export type DataClass = {};

export type CertificationDetails = {
  icon: null;
  logo: null;
  additional_text: null;
};

export type ImageURL = {
  image_url: string;
  sequence: number;
};

export type S3CERT = {
  url: null;
};

export type S3Image = {
  url: null;
  thumb: S3CERT;
};

export type VendorInfo = {
  company_name: string;
  street_address: string;
  email: string;
  contact_phone: string;
  jbt_detail: JbtDetail;
  country_code: string;
};

export type JbtDetail = {
  member_type: string;
  jbt_id: number;
  icon_url: string;
  info_text: string;
  web_url: string;
  member_type_id: number;
  access: Access;
  logo_url: string;
};

export type Access = {
  rating: boolean;
  report: boolean;
};

export type StockItemRequestMessages = {
  title?: string;
  stock_item_request_messages?: StockItemRequestMessage[];
};

export type StockItemRequestMessage = {
  id: number;
  stock_item_request_id: number;
  user_id: number;
  name: string;
  message: string;
  created_at: string;
  time?: string;
};

export type StockItemRequestMessagesSorted = {
  date: string;
  messages: StockItemRequestMessage[];
};

export enum MessageSentType {
  SENT = "sent",
  RECEIVED = "received",
}

export enum MemoStatus {
  Sold = "sold",
  Return = "return",
}
